import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import { mainReducers } from './mainReducers';

export const initialState = {};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...mainReducers,
});

export default reduceReducers(rootReducer);
